@if (viewModel) { @if (viewModel.link) {
<a
  [ecmDisabledAction]="linkDisable || isDisabledEclairLink"
  [href]="viewModel.link | link:getLinkParam() | async"
  (click)="openLink();false"
  class="align-items-start"
  data-e2e="sub-item-link"
>
  <ng-container *ngTemplateOutlet="item"></ng-container>
</a>
} @else {
<div class="align-items-start" data-e2e="sub-item">
  <ng-container *ngTemplateOutlet="item"></ng-container>
</div>
} }

<ng-template #item>
  <div [ngClass]="{'border-bottom-0': hideBorder, 'pb-0': viewModel.noExtraBalance}">
    <div class="item-text">
      <span [attr.aria-label]="viewModel.label + ' du ' + offer.name" class="lead" data-e2e="sub-item-label"
        ><strong>{{viewModel.label}}</strong></span
      >
      <div class="progressbar progressbar-length m-0">
        <div class="d-flex justify-content-between">
          <div class="progressbar-label label-content" data-e2e="sub-item-consumption">{{viewModel.consumption}}</div>
          <span class="progressbar-label" data-e2e="sub-item-totalData">{{viewModel.totalData}}</span>
        </div>
        <progress data-e2e="sub-item-gauge" max="100" value="{{viewModel.gaugePercent}}"></progress>
      </div>
      @if (viewModel.noExtraBalance) {
      <span class="progressbar-label-top" data-e2e="sub-item-noExtraBalance">{{viewModel.noExtraBalance}}</span>
      }
    </div>
    @if (viewModel.alert) {
    <i
      data-e2e="sub-item-alert"
      class="item-status icon-info icon-Warning-important text-warning"
      aria-hidden="true"
    ></i>
    }
  </div>
</ng-template>
